/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import PropTypes from "prop-types";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import redfallProjectImage from "assets/images/portfolio/RedfallProjectImage.png";
import runeProjectImage from "assets/images/portfolio/RuneProjectImage.png";
import survivedByProjectImage from "assets/images/portfolio/SurvivedByProjectImage.png";
import superWallCrashProjectImage from "assets/images/portfolio/SuperWallCrashProjectImage.png";
import thereAre200ProjectImage from "assets/images/portfolio/ThereAre200ProjectImage.png";
import jamsPrototypesProjectImage from "assets/images/portfolio/JamsPrototypesProjectImage.png";

function ProjectsSection({
  toggleRedfallModal,
  toggleRuneModal,
  toggleSBModal,
  toggleSWCModal,
  toggleTATModal,
  toggleJamModal,
}) {
  return (
    <MKBox
      bgColor="#343434"
      borderRadius="xl"
      shadow="lg"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      mt={{ xs: 10, sm: 10, md: 10 }}
      mb={{ xs: 10, sm: 10, md: 10 }}
      mx={3}
    >
      <MKBox
        variant="gradient"
        bgColor="info"
        coloredShadow="secondary"
        borderRadius="lg"
        p={2}
        mx={2}
        mt={-3}
      >
        <MKTypography
          variant="h1"
          color="white"
          sx={{ overflowWrap: "break-word", textAlign: "center" }}
        >
          Project Portfolio
        </MKTypography>
      </MKBox>
      <MKBox p={3}>
        <MKTypography variant="body1" color="white" fontWeight="bold">
          Click a project to find out more...
        </MKTypography>
        <br />
        <MKBox
          borderRadius="10px"
          coloredShadow="secondary"
          shadow="lg"
          onClick={toggleRedfallModal}
          overflow="hidden"
          sx={{
            cursor: "pointer",
            "&:hover": {
              boxShadow: "0 0px 20px rgba(181, 0, 255)",
            },
          }}
        >
          <center>
            <MKBox
              component="img"
              src={redfallProjectImage}
              alt="Redfall"
              width="100%"
              sx={{
                verticalAlign: "middle",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            />
          </center>
        </MKBox>
        <br />
        <MKBox
          borderRadius="10px"
          coloredShadow="secondary"
          shadow="lg"
          onClick={toggleRuneModal}
          overflow="hidden"
          sx={{
            cursor: "pointer",
            "&:hover": {
              boxShadow: "0 0px 20px rgba(181, 0, 255)",
            },
          }}
        >
          <center>
            <MKBox
              component="img"
              src={runeProjectImage}
              alt="Redfall"
              width="100%"
              sx={{
                verticalAlign: "middle",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            />
          </center>
        </MKBox>
        <br />
        <MKBox
          borderRadius="10px"
          coloredShadow="secondary"
          shadow="lg"
          onClick={toggleSBModal}
          overflow="hidden"
          sx={{
            cursor: "pointer",
            "&:hover": {
              boxShadow: "0 0px 20px rgba(181, 0, 255)",
            },
          }}
        >
          <center>
            <MKBox
              component="img"
              src={survivedByProjectImage}
              alt="Redfall"
              width="100%"
              sx={{
                verticalAlign: "middle",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            />
          </center>
        </MKBox>
        <br />
        <MKBox
          borderRadius="10px"
          coloredShadow="secondary"
          shadow="lg"
          onClick={toggleSWCModal}
          overflow="hidden"
          sx={{
            cursor: "pointer",
            "&:hover": {
              boxShadow: "0 0px 20px rgba(181, 0, 255)",
            },
          }}
        >
          <center>
            <MKBox
              component="img"
              src={superWallCrashProjectImage}
              alt="Redfall"
              width="100%"
              sx={{
                verticalAlign: "middle",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            />
          </center>
        </MKBox>
        <br />
        <MKBox
          borderRadius="10px"
          coloredShadow="secondary"
          shadow="lg"
          onClick={toggleTATModal}
          overflow="hidden"
          sx={{
            cursor: "pointer",
            "&:hover": {
              boxShadow: "0 0px 20px rgba(181, 0, 255)",
            },
          }}
        >
          <center>
            <MKBox
              component="img"
              src={thereAre200ProjectImage}
              alt="Redfall"
              width="100%"
              sx={{
                verticalAlign: "middle",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            />
          </center>
        </MKBox>
        <br />
        <MKBox
          borderRadius="10px"
          coloredShadow="secondary"
          shadow="lg"
          onClick={toggleJamModal}
          overflow="hidden"
          sx={{
            cursor: "pointer",
            "&:hover": {
              boxShadow: "0 0px 20px rgba(181, 0, 255)",
            },
          }}
        >
          <center>
            <MKBox
              component="img"
              src={jamsPrototypesProjectImage}
              alt="Redfall"
              width="100%"
              sx={{
                verticalAlign: "middle",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            />
          </center>
        </MKBox>
        <br />
      </MKBox>
    </MKBox>
  );
}

ProjectsSection.propTypes = {
  toggleRedfallModal: PropTypes.func.isRequired,
  toggleRuneModal: PropTypes.func.isRequired,
  toggleSBModal: PropTypes.func.isRequired,
  toggleSWCModal: PropTypes.func.isRequired,
  toggleTATModal: PropTypes.func.isRequired,
  toggleJamModal: PropTypes.func.isRequired,
};

export default ProjectsSection;
